import url from 'url'

export default () => {
    
    const queryFromReq = (req) => {
       // let url= new URL(req.url);
       // let params = new URLSearchParams(url.search);
        const urlObj =  url.parse(req.url, true)
        return urlObj.query
    }

    const paramsFromReqUrl = (req) => {
        const urlObj =  url.parse(req.url, true)
        let params =  new URLSearchParams(urlObj.search)
        params.delete('login')
        return params
    }

    return { queryFromReq,  paramsFromReqUrl}
}